// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
} from "@hey-api/client-fetch";
import type {
  AccountLookupData,
  AccountLookupError,
  AccountLookupResponse,
  Auth0Data,
  Auth0Error,
  Auth0Response,
  AvelaAiData,
  AvelaAiError,
  AvelaAiResponse,
  BrandingData,
  BrandingError,
  BrandingResponse,
  ContactsData,
  ContactsError,
  ContactsResponse,
  ExternalCapacityData,
  ExternalCapacityError,
  ExternalCapacityResponse,
  IdentityAiData,
  IdentityAiError,
  IdentityAiResponse,
  LoginData,
  LoginError,
  LoginResponse,
  MatchData,
  MatchError,
  MatchResponse,
  MfaData,
  MfaError,
  MfaResponse,
  OrgConfigData,
  OrgConfigError,
  OrgConfigResponse,
  PaymentsData,
  PaymentsError,
  PaymentsResponse,
  TranslationOptionsData,
  TranslationOptionsError,
  TranslationOptionsResponse,
} from "./types.gen";

export const client = createClient(createConfig());

export const orgConfig = <ThrowOnError extends boolean = false>(
  options: Options<OrgConfigData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    OrgConfigResponse,
    OrgConfigError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/{configType}.json",
  });
};

export const branding = <ThrowOnError extends boolean = false>(
  options: Options<BrandingData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    BrandingResponse,
    BrandingError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/Branding.json",
  });
};

export const contacts = <ThrowOnError extends boolean = false>(
  options: Options<ContactsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ContactsResponse,
    ContactsError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/Contacts.json",
  });
};

export const auth0 = <ThrowOnError extends boolean = false>(
  options: Options<Auth0Data, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    Auth0Response,
    Auth0Error,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/Auth0.json",
  });
};

export const login = <ThrowOnError extends boolean = false>(
  options: Options<LoginData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    LoginResponse,
    LoginError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/Login.json",
  });
};

export const translationOptions = <ThrowOnError extends boolean = false>(
  options: Options<TranslationOptionsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    TranslationOptionsResponse,
    TranslationOptionsError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/TranslationOptions.json",
  });
};

export const accountLookup = <ThrowOnError extends boolean = false>(
  options: Options<AccountLookupData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    AccountLookupResponse,
    AccountLookupError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/AccountLookup.json",
  });
};

export const match = <ThrowOnError extends boolean = false>(
  options: Options<MatchData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    MatchResponse,
    MatchError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/Match.json",
  });
};

export const avelaAi = <ThrowOnError extends boolean = false>(
  options: Options<AvelaAiData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    AvelaAiResponse,
    AvelaAiError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/AvelaAI.json",
  });
};

export const identityAi = <ThrowOnError extends boolean = false>(
  options: Options<IdentityAiData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    IdentityAiResponse,
    IdentityAiError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/IdentityAI.json",
  });
};

export const payments = <ThrowOnError extends boolean = false>(
  options: Options<PaymentsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    PaymentsResponse,
    PaymentsError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/Payments.json",
  });
};

export const externalCapacity = <ThrowOnError extends boolean = false>(
  options: Options<ExternalCapacityData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ExternalCapacityResponse,
    ExternalCapacityError,
    ThrowOnError
  >({
    ...options,
    url: "/{organizationPath}/ExternalCapacity.json",
  });
};

export const mfa = <ThrowOnError extends boolean = false>(
  options: Options<MfaData, ThrowOnError>
) => {
  return (options?.client ?? client).get<MfaResponse, MfaError, ThrowOnError>({
    ...options,
    url: "/{organizationPath}/Mfa.json",
  });
};
